module.exports = __webpack_public_path__ + "img/HANTI.cc13edb0.png";